import * as React from 'react';
import * as mobxReact from 'mobx-react';
import { CommonModal } from '../../../../../global/modal/common/common-modal';
import DefaultButton from '../../../../../global/default-button/default-button';
import { DefaultCloseModalButton } from '../../../../../global/modal/common/common-close-modal-buttons';
import { GenerateRoomsVM } from '../generate-rooms.viewmodel';
import { GenerateRoomsFormPresentation } from './_generate-rooms-form/generate-rooms-form.presentation';

import './generate-rooms-form.scss';

const GenerateRoomsModal = mobxReact.observer((props: { vm: GenerateRoomsVM; onSuccessCallBack?: () => void }) => {
    const footer = props.vm.isSaving() ? (
        <div className='oe-popup-layout__footer-status-area'>Rooms are currently creating and assigning...</div>
    ) : (
        <div className='buttons-block buttons-block--from-right'>
            <DefaultButton
                text='Create & Assign Rooms'
                modifier={['fat', 'confirm-safe']}
                onClick={() => props.vm.generateRooms().then(props.onSuccessCallBack)}
            />
            <DefaultCloseModalButton />
        </div>
    );

    return (
        props.vm && (
            <CommonModal
                title='Create & Assign Rooms'
                isOpen={props.vm.getIsFormShown()}
                onRequestClose={props.vm.hideAndResetForm}
                className='generate-rooms-modal'
                classNameBody='body__overflow'
                footer={footer}
            >
                <GenerateRoomsFormPresentation vm={props.vm} />
            </CommonModal>
        )
    );
});

export { GenerateRoomsModal };
